import { render, staticRenderFns } from "./CardPreviewLab.vue?vue&type=template&id=f11c60f6&scoped=true"
import script from "./CardPreviewLab.vue?vue&type=script&lang=js"
export * from "./CardPreviewLab.vue?vue&type=script&lang=js"
import style0 from "./CardPreviewLab.vue?vue&type=style&index=0&id=f11c60f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11c60f6",
  null
  
)

export default component.exports